import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const TruckTrailersSvg = () => (
  <svg width="24" height="24" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.9 20 2 20C3.1 20 4 19.1 4 18H12C12 19.1 12.9 20 14 20C15.1 20 16 19.1 16 18V2C16 0.9
      15.1 0 14 0ZM4.51 16.17H2V15.14H4.51V16.17ZM10.66 17.19H5.34V15.14H10.66V17.19ZM14 16.17H11.49V15.14H14V16.17ZM14
      14.3H2V12.22H14V14.3ZM14 11.77H2V9.67H14V11.77ZM14 9.22H2V7.12H14V9.22ZM14 6.66H2V4.56H14V6.66ZM14 4.11H2V2.04H14V4.11Z"
      fill="currentColor"
    />
    <path d="M8.95991 13.48H6.90991V13.9H8.95991V13.48Z" fill="currentColor" />
  </svg>
);

const TruckTrailers = (props: IIconProps) => <Icon component={TruckTrailersSvg} {...props} />;

export default TruckTrailers;
